import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20background%20in%20amber%20and%20coral%20tones%20with%20soft%20organic%20curves%20and%20subtle%20geometric%20patterns%20minimalist%20digital%20art%20style%20warm%20inviting%20atmosphere%20clean%20modern%20aesthetic%20with%20gentle%20light%20effects&width=1600&height=700&seq=wuma-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-accent-900/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6">
          准备好开始你的无码之旅了吗？
        </h2>
        <p className="text-base md:text-lg text-white/80 mb-10 leading-relaxed">
          加入100,000+企业和开发者，用无码平台快速构建你的下一个伟大产品。
          免费开始，零风险体验数字化创新的力量。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/about#contact"
            className="px-8 py-3.5 rounded-full bg-white text-primary-700 font-semibold text-base hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即免费试用
          </a>
          <Link
            to="/category/app-building"
            className="px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-sm text-white font-medium text-base border border-white/30 hover:bg-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            查看成功案例
          </Link>
        </div>
      </div>
    </section>
  );
}